import { HttpClient } from "@angular/common/http";
import { TemplateRef, Injectable } from "@angular/core";
import { Column } from "@universal-ui";
import { Observable } from "rxjs";

import { environment } from "@environments/environment";

import { TextAlignment } from "@shared/Enums/text-alignment.enum";

import { IUsuarioSeguros, AsociarUsuarioApp } from "../Types/Interfaces/asociar-usuario.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class CanalesAsociarUsuarioService {
  constructor(private readonly http: HttpClient) {}

  public setColumns(actionsTemplate: TemplateRef<unknown>): Column[] {
    return [
      {
        name: "Acciones",
        prop: "",
        width: 200,
        headerClass: TextAlignment.Center,
        cellTemplate: actionsTemplate,
        selected: true,
        dontPrint: true,
      },
      {
        name: "Identificación",
        prop: "identificacion",
        selected: true,
        width: 170,
      },
      {
        name: "Nombre",
        prop: "nombre",
        selected: true,
        width: 200,
      },
      {
        name: "Apellidos",
        prop: "apellido",
        selected: true,
        width: 300,
      },
      {
        name: "Correo Electrónico",
        prop: "email",
        width: 270,
        selected: true,
      },
      {
        name: "Origen",
        prop: "sources",
        selected: true,
        width: 150,
      },
    ];
  }

  public asociarUsuario(payload: IUsuarioSeguros): Observable<null> {
    const url: string = `${enlineaBackendUrl}/api/Usuarios/AsociarUsuario`;
    return this.http.post<null>(url, payload);
  }

  public consultarUsuarioApp(identificacion?: string, userCode?: string): Observable<AsociarUsuarioApp[]> {
    const params: {
      identificacion?: string;
      userCode?: string;
    } = {};

    if (identificacion) params.identificacion = identificacion;
    if (userCode) params.userCode = userCode;
    const url: string = `${enlineaBackendUrl}/api/Usuarios/ConsultarUsuarioAPP`;

    return this.http.get<AsociarUsuarioApp[]>(url, { params });
  }
}
